import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'row justify-content-md-center',
})`
  margin-top: 25px;

  .col-form-label {
    text-align: right;
  }

  .title-debitos {
    width: 100%;
    text-align: center;
    font-size: 20px;
    text-decoration: underline;
    margin-top: 0;
    margin-bottom: 10px;
  }

  .info-right-table {
    text-align: right;
  }

  .boletos-individuais {
    margin-bottom: 0;
    padding-top: 7px;
  }

  .info-observacoes {
    margin-bottom: 0;
    padding-top: 7px;
  }

  .base-resume-pagamento-boleto-cartao {
    background: #ccc;
    border-radius: 5px;
    padding: 10px;
    margin-left: 0px;
    margin-right: 0px;

    p {
      font-size: 20px;
      margin-top: 3px;
      margin-bottom: 0;
    }

    .btn-pagamento-boleto,
    .btn-pagamento-cartao {
      width: 100%;
      margin-top: 2px;
      margin-bottom: 2px;

      svg {
        margin-right: 5px;
        margin-bottom: 3px;
      }
    }
  }
`;
